import React from 'react';

import { LayoutPageHeading } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { DesignerEntity } from 'src/modules/designers';
import { DesignersListingOverview } from '../..';
import { useIntl } from 'react-intl';

type DesignersListingPageProps = {
  designersPage: {
    designers: DesignerEntity[];
  };
};

const DesignersListingPage: React.FunctionComponent<DesignersListingPageProps> = (props) => {
  const intl = useIntl();

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/designers/head/page_title' }),
    description: intl.formatMessage({ id: 'page/designers/head/meta_description' }),
    breadcrumbs: [
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/designers',
        }),
        as: '/designers',
        href: '/designers',
      },
    ],
  };

  const { designersPage } = props;
  const { designers } = designersPage;

  return (
    <LayoutPage {...pageProperties}>
      <LayoutPageHeading
        titleKey="page/designers/listing/title"
        sublineKey="page/designers/listing/subline"
      />

      <DesignersListingOverview designers={designers} />
    </LayoutPage>
  );
};

export default DesignersListingPage;
